import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { MedusaTooltipProvider } from "libraries/medusa"
import { HelmetProvider } from "react-helmet-async"
import { Toaster } from "react-hot-toast"
import MasterRouter from "routers/master"
import { queryClient } from "utils/api/client/query-client"

function App() {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools
          initialIsOpen={Boolean(import.meta.env.VITE_OPEN_DEV_TOOL)}
        />
        <MedusaTooltipProvider>
          <MasterRouter />
        </MedusaTooltipProvider>
        <Toaster position="bottom-right" />
      </QueryClientProvider>
    </HelmetProvider>
  )
}

export default App
